(function () {
  const KEY = 'theme-recent';
  const MAX = 12;

  function safeParse(str) {
    try { return JSON.parse(str); } catch (e) { return null; }
  }

  function isValidEntry(v) {
    return v && typeof v.url === 'string' && typeof v.featuredImage === 'string';
  }

  function guard() {
    const raw = localStorage.getItem(KEY);
    if (!raw) return;

    const obj = safeParse(raw);

    // If corrupted JSON, clear it so theme JS doesn't die
    if (!obj || typeof obj !== 'object') {
      localStorage.removeItem(KEY);
      return;
    }

    // Filter invalid entries
    const entries = Object.entries(obj).filter(([, v]) => isValidEntry(v));

    // Cap to most recent MAX (object insertion order is generally preserved)
    const capped = entries.slice(-MAX);
    const rebuilt = Object.fromEntries(capped);

    const next = JSON.stringify(rebuilt);
    if (next !== raw) localStorage.setItem(KEY, next);
  }

  // run early + after load
  try { guard(); } catch(e) {}
  window.addEventListener('load', function () { try { guard(); } catch(e) {} });
})();
